import { render, staticRenderFns } from "./FooterPartial.vue?vue&type=template&id=57bdfb50&scoped=true&"
import script from "./FooterPartial.vue?vue&type=script&lang=js&"
export * from "./FooterPartial.vue?vue&type=script&lang=js&"
import style0 from "./FooterPartial.vue?vue&type=style&index=0&id=57bdfb50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bdfb50",
  null
  
)

export default component.exports